// FRAQUANE QUICK ADD V16 — sole Quick View variant/swatch authority; canonical variant IDs + modal media fallback + reapply observer.
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.fqQuickAddAbortController = null;
      this.ensureQuantityBridge();
    }
    ensureQuantityBridge() {
      if (window.fqChangeProductQuantity && window.fqChangeProductQuantity.__fqQuickAddReady) return;
      const changeQuantity = function(button, direction) {
        const wrap = button && button.closest('[data-fq-quantity-control]');
        const input = wrap && wrap.querySelector('input.quantity__input[name="quantity"]');
        if (!input) return false;
        const numberOr = (value, fallback) => {
          const n = Number(value);
          return Number.isFinite(n) ? n : fallback;
        };
        const min = Math.max(1, numberOr(input.min || input.dataset.min, 1));
        const step = Math.max(1, numberOr(input.step, 1));
        const hasMax = input.hasAttribute('max') || input.dataset.max !== undefined;
        const max = hasMax ? Math.max(0, numberOr(input.max || input.dataset.max, Infinity)) : Infinity;
        let value = numberOr(input.value, min);
        let next = value + (direction > 0 ? step : -step);
        next = Math.max(min, Math.min(max, next));
        if (next !== value) {
          input.value = String(next);
          input.setAttribute('value', String(next));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const minus = wrap.querySelector('[name="minus"]');
        const plus = wrap.querySelector('[name="plus"]');
        if (minus) minus.disabled = next <= min;
        if (plus) plus.disabled = Number.isFinite(max) && (max <= 0 || next + step > max);
        return false;
      };
      changeQuantity.__fqQuickAddReady = true;
      window.fqChangeProductQuantity = changeQuantity;
    }
    syncQuickAddQuantity() {
      const wrap = this.modalContent.querySelector('[data-fq-quantity-control]');
      const input = wrap && wrap.querySelector('input.quantity__input[name="quantity"]');
      if (!input) return;
      const min = Math.max(1, Number(input.min || input.dataset.min || 1));
      const step = Math.max(1, Number(input.step || 1));
      const maxValue = input.hasAttribute('max') ? Number(input.max) : null;
      const value = Number(input.value || min);
      const minus = wrap.querySelector('[name="minus"]');
      const plus = wrap.querySelector('[name="plus"]');
      if (minus) minus.disabled = value <= min;
      if (plus && Number.isFinite(maxValue)) plus.disabled = maxValue <= 0 || value + step > maxValue;
    }
    hide(preventFocus = false) {
      if (this.fqQuickAddAbortController) {
        this.fqQuickAddAbortController.abort();
        this.fqQuickAddAbortController = null;
      }
      if (this.fqSwatchObserver) {
        this.fqSwatchObserver.disconnect();
        this.fqSwatchObserver = null;
      }
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }
    show(opener) {
      if (this.fqQuickAddAbortController) {
        this.fqQuickAddAbortController.abort();
      }
      const abortController = new AbortController();
      this.fqQuickAddAbortController = abortController;
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'), { signal: abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(`Quick Add fetch failed: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) {
            throw new Error('Quick Add: MainProduct section not found.');
          }
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.initFraquaneQuickAddGallery();
          this.initFraquaneVariantBridge();
          void this.initFraquaneQuickAddSwatches(opener);
          this.initFraquaneSwatchObserver(opener);
          this.syncQuickAddQuantity();
          super.show(opener);
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          console.error(error);
        })
        .finally(() => {
          if (this.fqQuickAddAbortController === abortController) {
            this.fqQuickAddAbortController = null;
          }
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          const spinner = opener.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }
    setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');
    }
    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();
      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
      const modalDialogs = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialogs.length) {
        modalDialogs.forEach((modal) => modal.remove());
      }
    }
    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
        sectionId,
        `quickadd-${sectionId}`
      );
      this.productElement
        .querySelectorAll('variant-selects, variant-radios, product-info')
        .forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
    }
    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;
      galleryList.setAttribute('role', 'presentation');
      galleryList
        .querySelectorAll('[id^="Slide-"]')
        .forEach((item) => item.setAttribute('role', 'presentation'));
    }
    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      if (!product) return;
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;
      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;
      let mediaImageSizes =
        '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }
      mediaImages.forEach((img) => {
        img.setAttribute('sizes', mediaImageSizes);
        img.setAttribute('draggable', 'false');
      });
    }
  async initFraquaneQuickAddSwatches(opener = null) {
    const picker = this.modalContent.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    const json = picker.querySelector('script[type="application/json"]');
    let localizedVariants = [];
    try {
      localizedVariants = json ? JSON.parse(json.textContent || '[]') : [];
    } catch (_) {
      localizedVariants = [];
    }
    if (!Array.isArray(localizedVariants) || !localizedVariants.length) return;
    const colourName = /(?:^|\b)(color|colors|colour|colours|couleur|couleurs|farbe|farben|colore|colori|cor|cores|kleur|kleuren|färg|färger|farger|farve|farver|kolor|kolory|barva|barvy|farba|farby|väri|värit|culoare|culori|szín|szinek|színek|spalva|spalvos|boja|boje|χρώμα|χρωμα|цвят|цвет|цветове)(?:\b|$)/i;
    const imageUrl = (image) => {
      if (!image) return '';
      if (typeof image === 'string') return image;
      if (image.preview_image) {
        const nested = imageUrl(image.preview_image);
        if (nested) return nested;
      }
      if (image.image) {
        const nested = imageUrl(image.image);
        if (nested) return nested;
      }
      return String(image.src || image.url || image.original_src || '').trim();
    };
    const handleFromUrl = (value) => {
      if (!value) return '';
      try {
        const u = new URL(value, window.location.origin);
        const m = u.pathname.match(/\/products\/([^/?#]+)/i);
        return m && m[1] ? decodeURIComponent(m[1]) : '';
      } catch (_) {
        return '';
      }
    };
    const mediaImageFromModal = (mediaId) => {
      const id = String(mediaId || '');
      if (!id) return '';
      const nodes = this.modalContent.querySelectorAll('[data-media-id]');
      for (const node of nodes) {
        const dataId = String(node.getAttribute('data-media-id') || '');
        if (dataId === id || dataId.endsWith(`-${id}`)) {
          const img = node.querySelector('img');
          const src = String(img?.currentSrc || img?.getAttribute('src') || '').trim();
          if (src) return src;
        }
      }
      return '';
    };
    const variantMediaId = (variant) => String(
      variant?.featured_media?.id ||
      variant?.featured_image?.id ||
      variant?.image_id ||
      ''
    );
    const directVariantImage = (variant, productImages = []) => {
      if (!variant) return '';
      const direct = imageUrl(variant.featured_media) || imageUrl(variant.featured_image) || imageUrl(variant.image);
      if (direct) return direct;
      const mediaId = variantMediaId(variant);
      const domImage = mediaImageFromModal(mediaId);
      if (domImage) return domImage;
      if (mediaId && Array.isArray(productImages)) {
        const byId = productImages.find((image) => String(image?.id || '') === mediaId);
        const mapped = imageUrl(byId);
        if (mapped) return mapped;
      }
      return '';
    };
    const openerUrl = opener?.getAttribute?.('data-product-url') || this.openedBy?.getAttribute?.('data-product-url') || picker.getAttribute('data-url') || '';
    const handle = handleFromUrl(openerUrl) || handleFromUrl(picker.getAttribute('data-url'));
    let canonicalProduct = null;
    if (handle) {
      try {
        const canonicalUrl = new URL(`/products/${encodeURIComponent(handle)}.js`, window.location.origin);
        canonicalUrl.searchParams.set('fq_variant_media', 'canonical_v16');
        const response = await fetch(canonicalUrl.toString(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
        if (response.ok) {
          const payload = await response.json();
          canonicalProduct = payload?.product || payload || null;
        }
      } catch (_) {}
    }
    const canonicalVariants = Array.isArray(canonicalProduct?.variants) ? canonicalProduct.variants : [];
    const canonicalImages = Array.isArray(canonicalProduct?.images) ? canonicalProduct.images : [];
    const canonicalById = new Map(
      canonicalVariants.filter((v) => v && v.id != null).map((v) => [String(v.id), v])
    );
    const mergedVariants = localizedVariants.map((variant) => {
      if (!variant || variant.id == null) return variant;
      const canonical = canonicalById.get(String(variant.id)) || null;
      return {
        ...variant,
        __fqImage:
          directVariantImage(canonical, canonicalImages) ||
          directVariantImage(variant, canonicalImages)
      };
    });
    const groups = Array.from(picker.querySelectorAll('.product-form__input')).filter((group) => group.querySelector('input[type="radio"]'));
    groups.forEach((group, optionIndex) => {
      const legend = group.querySelector('legend, .form__label');
      const legendText = String(legend?.textContent || '').replace(/[:：]/g, ' ').replace(/\s+/g, ' ').trim();
      const classText = String(group.className || '').replace(/[-_]/g, ' ');
      const hasVariantImages = localizedVariants.some((v) => directVariantImage(v, canonicalImages));
      const isColourAxis =
        colourName.test(legendText) ||
        /product form input swatch/i.test(classText) ||
        colourName.test(classText) ||
        (optionIndex === 0 && hasVariantImages);
      if (!isColourAxis) return;
      group.classList.add('fq-quickadd-image-swatch-group');
      Array.from(group.querySelectorAll('input[type="radio"]')).forEach((input) => {
        const value = String(input.value || '').trim();
        if (!value) return;
        let label = null;
        if (input.id) {
          try { label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`); } catch (_) {}
        }
        if (!label && input.nextElementSibling?.tagName === 'LABEL') label = input.nextElementSibling;
        if (!label) return;
        const matches = mergedVariants.filter((variant) =>
          variant && Array.isArray(variant.options) && String(variant.options[optionIndex] || '') === value
        );
        const matched =
          matches.find((v) => v.available && v.__fqImage) ||
          matches.find((v) => v.__fqImage) ||
          matches.find((v) => v.available) ||
          matches[0] || null;
        const src = String(matched?.__fqImage || '').trim();
        if (!src) return;
        label.classList.remove('fq-premium-swatch-label', 'fq-model-pill');
        label.classList.add('fq-visual-option-image', 'fq-quickadd-variant-image-swatch');
        label.style.setProperty('background-image', `url("${src.replace(/"/g, '%22')}")`, 'important');
        label.style.setProperty('background-size', 'cover', 'important');
        label.style.setProperty('background-position', 'center', 'important');
        label.style.setProperty('background-repeat', 'no-repeat', 'important');
        label.style.setProperty('color', 'transparent', 'important');
        label.style.setProperty('font-size', '0', 'important');
        label.setAttribute('data-fq-tooltip', value);
        label.setAttribute('aria-label', value);
        label.setAttribute('title', value);
        label.dataset.fqVariantId = String(matched?.id || '');
      });
    });
  }
  initFraquaneSwatchObserver(opener = null) {
    if (this.fqSwatchObserver) this.fqSwatchObserver.disconnect();
    let timer = 0;
    const rerun = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        void this.initFraquaneQuickAddSwatches(opener || this.openedBy);
      }, 30);
    };
    this.fqSwatchObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'childList' || mutation.type === 'attributes')) rerun();
    });
    this.fqSwatchObserver.observe(this.modalContent, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
    window.setTimeout(rerun, 80);
    window.setTimeout(rerun, 220);
    window.setTimeout(rerun, 500);
  }
    initFraquaneVariantBridge() {
      const picker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (!picker || picker.dataset.fqQuickAddVariantBridge === '1') return;
      picker.dataset.fqQuickAddVariantBridge = '1';
      const getVariantData = () => {
        const json = picker.querySelector('script[type="application/json"]');
        if (!json) return [];
        try {
          const parsed = JSON.parse(json.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.warn('Fraquane Quick Add: invalid variant JSON.', error);
          return [];
        }
      };
      const getSelectedOptions = () => {
        const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
        if (fieldsets.length) {
          return fieldsets.map((fieldset) => {
            const checked = fieldset.querySelector('input[type="radio"]:checked');
            const select = fieldset.querySelector('select');
            return checked ? checked.value : (select ? select.value : '');
          });
        }
        return Array.from(picker.querySelectorAll('select'), (select) => select.value);
      };
      const findCurrentVariant = () => {
        const selectedOptions = getSelectedOptions();
        if (!selectedOptions.length) return null;
        return getVariantData().find((variant) => {
          if (!variant || !Array.isArray(variant.options)) return false;
          return variant.options.every((option, index) => selectedOptions[index] === option);
        }) || null;
      };
      const activateVariantMedia = (variant) => {
        if (!variant || !variant.featured_media) return;
        const mediaId = variant.featured_media.id;
        const sectionId = picker.dataset.section;
        if (!mediaId || !sectionId) return;
        const mediaGallery = this.modalContent.querySelector(`[id^="MediaGallery-${sectionId}"]`);
        if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(`${sectionId}-${mediaId}`, true);
          return;
        }
        const target = this.modalContent.querySelector(`[data-media-id="${sectionId}-${mediaId}"], [data-media-id="${mediaId}"]`);
        if (!target) return;
        const gallery = target.closest('.product__media-list');
        if (!gallery) return;
        const desktop = window.matchMedia('(min-width: 750px)').matches;
        if (desktop) {
          gallery.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
        } else {
          gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      };
      const updateHiddenVariantInput = (variant) => {
        if (!variant || !variant.id) return;
        const sectionId = picker.dataset.section;
        const forms = this.modalContent.querySelectorAll(
          `#product-form-${sectionId}, #product-form-installment-${sectionId}, product-form form`
        );
        forms.forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          if (!input || String(input.value) === String(variant.id)) return;
          input.value = String(variant.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };
      const sync = () => {
        const variant = findCurrentVariant();
        if (!variant) return;
        updateHiddenVariantInput(variant);
        activateVariantMedia(variant);
        window.requestAnimationFrame(() => {
          this.syncQuickAddQuantity();
        });
      };
      picker.addEventListener('change', () => {
        // Let PlayBattle/Shopify finish its native variant update first, then
        // enforce media + form synchronization inside this Quick Add only.
        window.requestAnimationFrame(sync);
      });
      // Initial alignment for the variant selected when the modal opens.
      window.requestAnimationFrame(sync);
    }
    initFraquaneQuickAddGallery() {
      const gallery = this.modalContent.querySelector('.product__media-list');
      if (!gallery || gallery.dataset.fqQuickAddGallery === '1') return;
      gallery.dataset.fqQuickAddGallery = '1';
      let dragging = false;
      let moved = false;
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let startScrollTop = 0;
      const desktop = () => window.matchMedia('(min-width: 750px)').matches;
      const onPointerDown = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, video, model-viewer')) return;
        dragging = true;
        moved = false;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = gallery.scrollLeft;
        startScrollTop = gallery.scrollTop;
        gallery.classList.add('fq-quickadd-dragging');
        try {
          gallery.setPointerCapture(pointerId);
        } catch (_) {}
      };
      const onPointerMove = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
        if (!moved) return;
        if (desktop()) {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            event.preventDefault();
          }
          gallery.scrollTop = startScrollTop - dy * 1.7;
        } else {
          gallery.scrollLeft = startScrollLeft - dx * 1.35;
        }
      };
      const finishDrag = (event) => {
        if (!dragging) return;
        if (event && pointerId !== null && event.pointerId !== pointerId) return;
        dragging = false;
        gallery.classList.remove('fq-quickadd-dragging');
        try {
          if (pointerId !== null && gallery.hasPointerCapture(pointerId)) {
            gallery.releasePointerCapture(pointerId);
          }
        } catch (_) {}
        pointerId = null;
        setTimeout(() => {
          moved = false;
        }, 0);
      };
      gallery.addEventListener('pointerdown', onPointerDown, { passive: true });
      gallery.addEventListener('pointermove', onPointerMove, { passive: false });
      gallery.addEventListener('pointerup', finishDrag, { passive: true });
      gallery.addEventListener('pointercancel', finishDrag, { passive: true });
      gallery.addEventListener('lostpointercapture', finishDrag, { passive: true });
      gallery.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
      gallery.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false');
      });
    }
  });
}